"use strict";
import * as PIXI from "pixi.js";
import { gsap, Power3 } from "gsap";
// import TweenMax from "gsap";
import { Texture, Graphics } from "pixi.js";
import PixiPlugin from "gsap/PixiPlugin";
// import loading from "./loading.js";
// const breakPoint = 960;
// let resizeFlag;

// window.addEventListener(
//   "load",
//   () => {
//     if (breakPoint < window.innerWidth) {
//       resizeFlag = false;
//     } else {
//       resizeFlag = true;
//     }
//     resizeWindow();
//   },
//   false
// );

// const resizeWindow = () => {
//   window.addEventListener(
//     "resize",
//     () => {
//       if (breakPoint < window.innerWidth && resizeFlag) {
//         window.location.reload();
//         resizeFlag = false;
//       } else if (breakPoint >= window.innerWidth && !resizeFlag) {
//         resizeFlag = true;
//       }
//     },
//     false
//   );
// };
window.addEventListener("DOMContentLoaded", () => {
  // var svgCircleProgress1 = document.querySelector(".circle");
  // var svgCircleProgressPath1 = document.querySelector(".circle__anim");
  // var tween,
  //   percentElement = false;

  // TweenMax.set(svgCircleProgressPath1, { drawSVG: 0 });

  // function start() {
  //   tween = TweenMax.fromTo(
  //     svgCircleProgress1,
  //     2,
  //     {
  //       drawSVG: "0",
  //     },
  //     {
  //       drawSVG: "0 100%",
  //       onUpdate: setPercentage,
  //       // onComplete: repeat,
  //     }
  //   );
  // }

  // function setPercentage() {
  //   if (!percentElement) {
  //     percentElement = document.getElementById("percent");
  //   }
  //   var v = Math.round(tween.progress() * 360);
  //   //v /= 10; // for use when you want 0.1 % use 1000 above if you do
  //   percentElement.innerHTML = v; // + "%";
  //   percentElement.style.opacity = tween.progress();
  // }

  // // function repeat() {
  // //   // using setTimeout to give a bit of a delay before re-drawing the circle
  // //   setTimeout(start, 500);
  // // }

  // start();

  const documentBody = document.querySelector("body");
  documentBody.classList.remove("fadeout");
  const keyName = "viewed";
  const keyValue = true;

  if (!sessionStorage.getItem(keyName)) {
    sessionStorage.setItem(keyName, keyValue);
    console.log("初回の閲覧");
    const loading = document.querySelector(".loading");
    loading.classList.add("is-start");
    const ms = 3000;
    const formatter = new Intl.NumberFormat();
    Array.prototype.forEach.call(
      document.querySelectorAll(".loading-text__num"),
      function (el, i) {
        const start = new Date().getTime();
        const comma = el.textContent.indexOf(",") > -1;
        const max = parseInt(el.textContent.replace(/,/g, ""), 10);
        el.textContent = "0";
        let id = setInterval(function () {
          const currentTime = Math.min(new Date().getTime() - start, ms);
          const num = Math.floor((max * currentTime) / ms);
          el.textContent = comma ? formatter.format(num) : num;

          if (currentTime >= ms) clearInterval(id);
        }, 10);
      }
    );
    setTimeout(() => {
      const loading = document.querySelector(".loading");
      loading.classList.add("loaded");
    }, 3200);
  } else {
    console.log("2回目以降の閲覧");
    const loading = document.querySelector(".loading");
    loading.remove();
  }

  const basePlane = new SimplePlane(document.getElementById("js-canvas"));
  basePlane.start();
});

class SimplePlane {
  /* Constructor
	--------------------------------------------------------------------*/
  constructor(elm) {
    this.init(elm);
  }

  /* Method (初期設定)
	-------------------------------------------------------------------- */
  init(elm) {
    // dom
    this.parentElm = elm;
    this.canvas = this.parentElm.querySelector("canvas");

    this.verticesX = 200;
    this.verticesY = 2;

    // ticker
    this.curveRange = 0.07; //湾曲の度合

    this.borderX = innerWidth * 0.25;
    this.borderSecondary = innerWidth * 0.75;

    this.minWindowSize = 768;

    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;

    this.createApplication();
    this.buttons();
    this.pagination();
    // this.screenResize();

    // this.autoplay();
  }

  /* アプリケーション関連
	--------------------------------------------------------------------*/
  /**
   * Applicationインスタンス作成
   */
  createApplication() {
    this.app = new PIXI.Application({
      view: this.canvas,
      width: this.innerWidth,
      height: this.innerHeight,
      backgroundAlpha: 0,

      antialias: false,
      useContextAlpha: true,

      resolution: Window.devicePixelRatio || 2,
      autoResize: true,
      // resizeTo: window,
      autoDensity: true,
    });

    // このインスタンスのticker
    this.ticker = this.app.ticker;
    // このインスタンスのステージング処理
    this.stage = this.app.stage;

    this.scroll = 0;
    // 画像のロード処理
    const loader = this.app.loader;

    // borderLine

    this.textureWidth =
      this.innerWidth <= this.minWindowSize
        ? this.innerWidth / 1.4
        : this.innerWidth / 2.5; // 0
    this.halfTexture = this.textureWidth / 2;
    this.zeroPoint = this.innerWidth * 0.5; // 0
    this.leftPoint =
      this.innerWidth <= this.minWindowSize
        ? this.innerWidth * 0.1
        : this.innerWidth * 0.25;
    this.rightPoint =
      this.innerWidth <= this.minWindowSize
        ? this.innerWidth * 0.9
        : this.innerWidth * 0.75;
    this.plusOne = this.rightPoint + this.halfTexture;
    this.plusPlusOne =
      this.plusOne +
      this.halfTexture +
      this.textureWidth / 8 +
      this.halfTexture;
    this.minusOne = this.leftPoint - this.halfTexture;
    this.minusMinusOne =
      this.leftPoint -
      this.halfTexture -
      this.textureWidth / 8 -
      this.halfTexture;

    loader
      .add("./img/common/img_place_1.jpg")
      .add("./img/common/img_place_2.jpg")
      .add("./img/common/img_place_3.jpg")
      .add("./img/common/img_place_4.jpg");
    loader.load((l, resources) => {
      this.createPlanes();
    });
    this.screenResize();
  }

  /**
   * テクスチャ読み込み後、Mesh作成
   */
  createPlanes() {
    // 画像用の配列
    this.planes = [
      "./img/common/img_place_2.jpg",
      "./img/common/img_place_1.jpg",
      "./img/common/img_place_3.jpg",
      "./img/common/img_place_4.jpg",
    ];
    this.buttonUrl = [
      "./minatomirai/", // スライド4枚目
      "./shinagawa/", // スライド1枚目
      "./tech/", // スライド2枚目
      "./robothics/", // スライド1枚目
    ];
    // planeの持つデータを格納するようの配列
    this.thumbs = []; // 生成したsimpleplaneの配列
    this.buffers = []; // 生成したsimpleplaneのbuffer用の配列
    this.datas = []; // 変化させる用の座標データの配列
    this.originDatas = []; // 変化前の座標データの配列
    this.lengths = []; // 変化前の座標データの配列
    this.currentIndex = [];

    for (let i = 0; i < this.planes.length; i++) {
      const texture = new PIXI.Texture.from(this.planes[i]);
      this.plane = new PIXI.SimplePlane(
        texture,
        this.verticesX,
        this.verticesY
      );
      // plane size
      this.plane.sizeScale = this.textureWidth / texture.width;
      this.plane.width = this.textureWidth;
      this.plane.height = this.plane.width * 0.56;

      if (innerWidth <= this.minWindowSize) {
        this.planeShapeMax(i);
      } else {
        this.planeShapeMin(i);
      }

      // plane position
      this.plane.y = this.innerHeight / 2 - this.plane.height / 2;

      this.thumbs.push(this.plane);
      this.buffer = this.plane.geometry.getBuffer("aVertexPosition");
      this.buffers.push(this.buffer);

      this.data = this.buffer.data;
      this.datas.push(this.buffer.data);

      this.originData = this.data.slice();
      this.originDatas.push(this.originData);

      this.length = this.data.length;
      this.lengths.push(this.data.length);

      this.currentIndex.push(i);
      if (i === 0) {
        this.plane.interactive = false; // interactiveMode
        this.plane.buttonMode = false; // buttonMode
      } else {
        this.plane.interactive = true; // interactiveMode
        this.plane.buttonMode = true; // buttonMode
      }

      this.plane.roundPixels = true; // ピクセル補完

      this.stage.addChild(this.plane); //ステージング
    }
    // 下層ページへの遷移
    this.screenTransition();

    // ------------------------------------------------------
    const update = () => {
      this.draw();
    };
    this.ticker.add(update);
  }
  // PCサイズ
  planeShapeMax(count) {
    this.plane.x =
      count * (this.plane.width + this.plane.width / 17.2) -
      this.plane.width / 1.17;
  }
  // SPサイズ
  planeShapeMin(count) {
    this.plane.x =
      count * (this.plane.width + this.plane.width / 8) -
      this.plane.width / 2.66;
  }
  /* クリック遷移
	--------------------------------------------------------------------*/
  screenTransition() {
    this.thumbs.forEach((th, index) => {
      th.on("mousedown", () => {
        location.href = this.buttonUrl[index];
      });
      th.on("touchstart", () => {
        location.href = this.buttonUrl[index];
      });
    });
  }
  // インスタンス操作
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  draw() {
    const endAreaWidth = this.innerWidth - this.innerWidth * 0.75; // -1の横面積

    const amountWidth = this.innerWidth <= this.minWindowSize ? 0.06 : 0.9;
    const easeInCubic = (x) => {
      return x * x * x * amountWidth; // 変化量の計算
    };
    for (let j = 0; j < this.thumbs.length; j++) {
      const data = this.datas[j],
        origins = this.originDatas[j],
        len = this.lengths[j],
        lenHalf = len >> 1;

      for (let i = 0; i < len; i += 2) {
        const plane = this.thumbs[j];
        // オリジナルの座標配列から値を取得し計算 ・ オリジナルのx + プレーンのx移動値
        const x = origins[i] * plane.sizeScale + plane.x;
        const y = origins[i + 1];

        const curveMax = lenHalf > i ? -100 : 100;
        const xRatio = this.borderX >= x ? 1 - x / this.borderX : 0;
        const curveHeight = xRatio * curveMax * this.curveRange;
        const minusRatio =
          this.borderSecondary <= x
            ? (x - this.borderSecondary) / endAreaWidth
            : 0;
        const minusCurveHeight = minusRatio * curveMax * this.curveRange;

        if (this.borderX >= x) {
          data[i + 1] = y + easeInCubic(curveHeight); // 境界線borderXを超えたら、y軸を変化させる
        } else if (x >= this.borderSecondary) {
          data[i + 1] = y + easeInCubic(minusCurveHeight); // 境界線borderSecondaryを超えたら、y軸を変化させる
        } else {
          data[i + 1] = y; // 安全地帯では元の形を保持する
        }
      }
      this.buffers[j].update(); // バッファを更新（座標の計算を反映する
    }
  }
  // アニメ開始
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  start() {
    this.ticker.start();
  }
  // prevボタン
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  prev(diff) {
    // ＋側への移動量
    let moveMinus =
      this.innerWidth <= this.minWindowSize
        ? (this.ThumbWidth + this.ThumbWidth * 2.43) * -1
        : (this.ThumbWidth + this.ThumbWidth / 2) * -1;
    this.buttonMoves(moveMinus);
    this.thumbs.forEach((th, index) => {
      let movePrev =
        this.innerWidth <= this.minWindowSize
          ? th.position.x + (th.width + th.width / 16.5) * diff
          : th.position.x + (th.width + th.width / 8) * diff;
      gsap.to(th, {
        x: movePrev,
        onStart: () => {
          this.buttonStart();
        },
        onComplete: () => {
          this.buttonComplete();
        },
      });
    });
    if (this.currentDefault === 0) {
      this.currentDefault = this.thumbs.length;
    }
    for (let i = 0; i < diff; i++) {
      this.currentDefault--;
    }
  }
  // nextボタン
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  next(diff) {
    let movePlus =
      this.innerWidth <= this.minWindowSize
        ? this.plusPlusOne - this.ThumbWidth
        : this.plusPlusOne - this.ThumbWidth / 2;

    this.buttonMoves(movePlus);
    this.thumbs.forEach((th, index) => {
      let moveNext =
        this.innerWidth <= this.minWindowSize
          ? th.position.x - (th.width + th.width / 16) * diff
          : th.position.x - (th.width + th.width / 8) * diff;
      gsap.to(th, {
        x: moveNext,
        onStart: () => {
          this.buttonStart();
        },
        onComplete: () => {
          this.buttonComplete();
        },
      });
    });
    if (this.currentDefault >= this.thumbs.length - 1) {
      this.currentDefault = -1;
    }
    for (let i = 0; i < diff; i++) {
      this.currentDefault++;
    }
  }
  // クリック時移動量
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  buttonMoves(moves) {
    if (this.currentDefault === 1) {
      this.thumbs[3].x = moves;
    } else if (this.currentDefault === 2) {
      this.thumbs[0].x = moves;
    } else if (this.currentDefault === 3) {
      this.thumbs[1].x = moves;
    } else if (this.currentDefault === 0) {
      this.thumbs[2].x = moves;
    }
  }
  // クリック開始時処理
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  buttonStart() {
    this.nextBtn.classList.add("btn-invalid");
    this.prevBtn.classList.add("btn-invalid");
    this.textureShadow.classList.remove("is-active");
    this.paginationTargets.forEach((item) => {
      item.classList.remove("current");
    });
    this.placeTargets.forEach((item) => {
      item.classList.remove("active");
    });
  }
  // クリック完了時処理
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  buttonComplete() {
    this.nextBtn.classList.remove("btn-invalid");
    this.prevBtn.classList.remove("btn-invalid");
    this.textureShadow.classList.add("is-active");
    if (this.currentDefault === 1) {
      this.pagination1.classList.add("current");
      this.place1.classList.add("active");
    } else if (this.currentDefault === 2) {
      this.pagination2.classList.add("current");
      this.place2.classList.add("active");
    } else if (this.currentDefault === 3) {
      this.pagination3.classList.add("current");
      this.place3.classList.add("active");
    } else if (this.currentDefault === 0) {
      this.pagination4.classList.add("current");
      this.place4.classList.add("active");
    }
  }
  // ページネーションボタン
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  pagination() {
    this.paginationTargets.forEach((page, index) => {
      page.addEventListener("click", () => {
        this.currentLocation = index + 1;
        let targetDiff = this.currentLocation - this.currentDefault; // 現在地と行き先の差
        // prev用の処理
        if (this.currentDefault === 0 && targetDiff == 2) {
          this.thumbs[3].x =
            this.innerWidth <= this.minWindowSize
              ? this.plusPlusOne + (this.ThumbWidth / 2 + this.ThumbWidth / 2.6)
              : this.plusPlusOne + (this.ThumbWidth / 2 + this.ThumbWidth / 8);
        }
        if (targetDiff < 0) {
          if (-targetDiff === 1) {
            // 隣接の場合は1回分の処理
            this.prev(1);
          } else if (-targetDiff === 2) {
            // 隣接の場合は2回分の処理
            let prevDiff2 =
              this.innerWidth <= this.minWindowSize
                ? this.minusMinusOne -
                  this.ThumbWidth * 2 -
                  this.ThumbWidth * 1.55
                : this.minusMinusOne -
                  this.ThumbWidth * 2 -
                  this.ThumbWidth / 8;
            if (this.currentLocation === 1) {
              // 3 → 1 の時
              this.thumbs[0].x = prevDiff2;
            } else if (this.currentLocation === 2) {
              // 4 → 2 の時
              // this.thumbs[1].x = prevDiff2;
              // this.thumbs[2].x =
              //   prevDiff2 + this.ThumbWidth + this.ThumbWidth / 8;
            }
            this.prev(2);
          } else if (-targetDiff === 3) {
            // 隣接の場合は3回分の処理
            this.next(1);
          }
        } else if (targetDiff > 0) {
          // next用の処理
          if (targetDiff === 1) {
            // 隣接の場合は一回分の処理
            this.next(1);
          } else if (targetDiff === 2) {
            let plusDiff2 =
              this.innerWidth <= this.minWindowSize
                ? this.plusPlusOne +
                  (this.ThumbWidth / 2 + this.ThumbWidth / 2.6)
                : this.plusPlusOne +
                  (this.ThumbWidth / 2 + this.ThumbWidth / 8);
            if (this.currentLocation === 3) {
              // 1 → 3 の時
              this.thumbs[0].x = plusDiff2;
            } else if (this.currentLocation === 4) {
              this.currentDefault = -2;
              // 2 → 4 の時
              this.thumbs[0].x =
                this.innerWidth <= this.minWindowSize
                  ? plusDiff2 - (this.ThumbWidth + this.ThumbWidth / 1.12)
                  : plusDiff2 - (this.ThumbWidth + this.ThumbWidth / 8);

              this.thumbs[1].x = plusDiff2;
            }
            this.next(2);
          } else if (targetDiff === 3) {
            this.prev(1);
          }
        }
      });
    });
  }
  // ボタン処理
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  buttons() {
    // // ページネーション用
    this.pagination1 = document.querySelector(".switch1");
    this.place1 = document.querySelector(".place1");
    this.pagination2 = document.querySelector(".switch2");
    this.place2 = document.querySelector(".place2");
    this.pagination3 = document.querySelector(".switch3");
    this.place3 = document.querySelector(".place3");
    this.pagination4 = document.querySelector(".switch4");
    this.place4 = document.querySelector(".place4");

    // next / prev用
    this.paginationTargets = document.querySelectorAll(
      ".slider-pagination__item"
    );

    this.placeTargets = document.querySelectorAll(".kv-place");
    this.textureShadow = document.querySelector(".kv-shadow");

    this.nextBtn = document.querySelector(".slider-nav-next");
    this.prevBtn = document.querySelector(".slider-nav-prev");
    this.ThumbWidth = innerWidth / 2.5;
    // テクスチャの基準値【枚目】
    this.currentDefault = 1;
    // console.log("現在地 : " + this.currentDefault);
    this.nextBtn.addEventListener("click", () => {
      this.next(1);
    });

    this.prevBtn.addEventListener("click", () => {
      this.prev(1);
    });
  }
  // リサイズ処理
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  resizeProcess() {
    window.location.reload(); // 最悪リサイズごとにリロード]
    // var size = [1920];
    // var ratio = size[0] / size[1];
    // if (window.innerWidth / window.innerHeight >= ratio) {
    //   var w = window.innerHeight * ratio;
    //   var h = window.innerHeight;
    // } else {
    //   var w = window.innerWidth;
    //   var h = window.innerWidth / ratio;
    // }
    // this.app.renderer.view.style.width = w + "px";
    // this.app.renderer.view.style.height = h + "px";
    // this.app.renderer.resize(this.innerWidth, this.innerHeight);
    // this.app.renderer.render(this.stage);
    // const update = () => {
    //   this.resizeProcess();
    // };
    // this.ticker.add(update);
    // // console.log(this.app.renderer.view.height);
    // // console.log(this.app.renderer.view.width);
    console.log("大丈夫、動いてる");
    // this.innerWidth = this.app.renderer.width;
    // this.app.renderer.render(this.stage);
    // const DEFAULT_WIDTH = 1500;
    // const DEFAULT_HEIGHT = 1000;
    // window.addEventListener("resize", () => {
    //   console.log("動いてる");

    //   const width = this.innerWidth;
    //   const height = this.innerHeight;

    //   const scaleX = width / DEFAULT_WIDTH;
    //   const scaleY = height / DEFAULT_HEIGHT;

    //   const minScale = Math.min(scaleX, scaleY);

    //   this.stage.scale.set(minScale, minScale);

    //   // this.stage.position(0.5, 0.5);
    // });
  }
  screenResize() {
    // window.addEventListener("load", () => {
    window.addEventListener("resize", () => {
      this.resizeProcess();
    });
    // });
  }
  autoplay() {
    setInterval(() => {
      this.next(1);
    }, 6000);
  }
}
